module.exports = __webpack_public_path__ + "static/sift-dashboard-5c8dc5612c68b5d33d7349f9c32a233c.png";